import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=61b6942b&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=js"
export * from "./ImageViewer.vue?vue&type=script&lang=js"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=61b6942b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6942b",
  null
  
)

export default component.exports